var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#ff2e00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.2818 9.23082c1.586 0 2.8718 1.28578 2.8718 2.87178v13.3905l-.0026.0604c-.1318 3.1286.6561 5.0242 1.6213 6.0891.9393 1.0363 2.3832 1.6605 4.4054 1.5837l.0545-.002h2.1265c1.586 0 2.8718 1.2857 2.8718 2.8717 0 1.5861-1.2858 2.8718-2.8718 2.8718h-2.0205c-3.3559.1141-6.5444-.9556-8.8215-3.468-2.2528-2.4854-3.2689-6.0011-3.1067-10.1256v-13.2716c0-1.586 1.2857-2.87178 2.8718-2.87178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7178 18.4616c0-1.5861 1.2857-2.8718 2.8718-2.8718h12.7179c1.5861 0 2.8718 1.2857 2.8718 2.8718 0 1.586-1.2857 2.8718-2.8718 2.8718h-12.7179c-1.5861 0-2.8718-1.2858-2.8718-2.8718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5639 8.82056c0-.56644.4592-1.02564 1.0257-1.02564 1.1314 0 2.2517.22285 3.2969.65581 1.0453.43296 1.9951 1.06757 2.7951 1.86757s1.4346 1.7498 1.8675 2.795c.433 1.0453.6559 2.1656.6559 3.297 0 .5665-.4592 1.0256-1.0257 1.0256-.5664 0-1.0256-.4591-1.0256-1.0256 0-.862-.1698-1.7156-.4997-2.512s-.8134-1.52-1.4229-2.1295-1.3332-1.0931-2.1296-1.4229c-.7964-.3299-1.6499-.4997-2.5119-.4997-.5665 0-1.0257-.45919-1.0257-1.02564z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5639 12.5129c0-.5665.4592-1.0257 1.0257-1.0257.6465 0 1.2867.1274 1.8839.3748.5973.2474 1.1401.61 1.5972 1.0672.4572.4571.8198.9998 1.0672 1.5971s.3747 1.2375.3747 1.884c0 .5665-.4591 1.0256-1.0256 1.0256-.5664 0-1.0256-.4591-1.0256-1.0256 0-.3771-.0743-.7506-.2186-1.099-.1444-.3484-.3559-.665-.6226-.9317-.2666-.2666-.5832-.4782-.9316-.6225-.3485-.1443-.7219-.2186-1.099-.2186-.5665 0-1.0257-.4592-1.0257-1.0256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuya);
export default __webpack_public_path__ + "static/media/tuya.40fcb0bb3f34653d52065d5e67c288df.svg";
export { ForwardRef as ReactComponent };